import { MembershipBadgeType } from '@freelancer/ui/badge';
import { UsersSelf } from '../users-self/users-self.model';
import { User } from '../users/users.model';
import { generateAvatar } from '../users/users.seed';
import { UserInfo } from './user-info.model';

export interface GenerateUserInfoOptions {
  readonly userId: number;
  readonly username?: string;
  readonly publicName?: string;
}

export function generateUserInfoObject({
  userId,
  username = 'testUsername',
  publicName = 'Test Name',
}: GenerateUserInfoOptions): UserInfo {
  return {
    id: userId.toString(),
    userId,
    username,
    publicName,
    isFreeTrialEligible: false,
    isPlusTrialEligible: false,
    isPremium: false,
    avatar: generateAvatar(userId),
    membership: 'plus',
    membershipBadge: MembershipBadgeType.MONTHLY_LEVEL_THREE,
    hideMembershipUpgradeButton: false,
    monthlyTrial: false,
    canSwitchToUsers: [],
    isNoCommissionEligibleReferrer: false,
    isCorporate: false,
  };
}

export function userInfoFromUser(
  user: User | UsersSelf,
): Pick<GenerateUserInfoOptions, 'userId' | 'username' | 'publicName'> {
  return {
    userId: user.id,
    username: user.username,
    publicName: user.displayName,
  };
}
